import {useMemo} from 'react'

import {UpmPlantContext} from '../contexts'
import {useUpmPlantsContext} from '../hooks'

interface UpmPlantProviderProps {
  children: React.ReactNode
  plantUpmId: string
}

export const UpmPlantProvider: React.FC<UpmPlantProviderProps> = ({children, plantUpmId}) => {
  const plants = useUpmPlantsContext()

  const resolvedPlant = useMemo(() => {
    const found = Object.values(plants).find((p) => p.upmId === plantUpmId)
    if (!found) {
      throw new Error(`UpmPlantProvider: No plant found for plantUpmId "${plantUpmId}"`)
    }
    return found
  }, [plantUpmId, plants])

  return <UpmPlantContext.Provider value={resolvedPlant}>{children}</UpmPlantContext.Provider>
}
